(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-tipsinfo-support.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-tipsinfo-support.js');
"use strict";


const {
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const {
  selectTipsinfoSupport
} = svs.components.tipsen.engine.selectors.engineSelectors;
const useTipsinfoSupport = () => {
  const tipsinfoSupport = useSelector(selectTipsinfoSupport);
  const allSupportedTipsinfo = useMemo(() => Object.keys(tipsinfoSupport).filter(key => tipsinfoSupport[key]).sort(), [tipsinfoSupport]);
  const allNonSupportedTipsinfo = useMemo(() => Object.keys(tipsinfoSupport).filter(key => !tipsinfoSupport[key]).sort(), [tipsinfoSupport]);
  return {
    tipsinfoSupport,
    allSupportedTipsinfo,
    allNonSupportedTipsinfo
  };
};
setGlobal('svs.components.tipsen.hooks.useTipsinfoSupport', useTipsinfoSupport);

 })(window);